export default __webpack_public_path__ + "static/media/cart.f26d8e96.webp";